import React from 'react';
interface TicketTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}
const TicketTabs: React.FC<TicketTabsProps> = ({
  activeTab,
  onTabChange
}) => {
  return <div className="border-b border-gray-200" data-id="element-1251">
      <nav className="-mb-px flex space-x-8" data-id="element-1252">
        <button onClick={() => onTabChange('groups')} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'groups' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1253">
          Ticket Groups
        </button>
        <button onClick={() => onTabChange('tickets')} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'tickets' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1254">
          All Tickets Records
        </button>
      </nav>
    </div>;
};
export default TicketTabs;